'use client'

import { createContext, type ReactNode, useContext } from 'react'
import type { ProductWithMetadata } from '@/lib/polar/types'

type ProductsContextType = {
  productsPromise: Promise<ProductWithMetadata[]>
} | null

const ProductsContext = createContext<ProductsContextType>(null)

interface ProductsProviderProps {
  productsPromise: Promise<ProductWithMetadata[]>
  children: ReactNode
}

export function ProductsProvider({ children, productsPromise }: ProductsProviderProps) {
  return <ProductsContext.Provider value={{ productsPromise }}>{children}</ProductsContext.Provider>
}

export function useProducts() {
  const context = useContext(ProductsContext)
  if (!context) {
    throw new Error('useProducts must be used within a ProductsProvider')
  }
  return context
}
